import ToggleSection from 'components/shared/ToggleSection'
import { HOURS_AVAILABILITY_MODES } from 'app/modules/teams/constants'
import { isTeamOnline } from 'utils/TeamOnlineStatusHelper'
import cx from 'classnames'

import './style.styl'

const AvailabilityLabel = ({ isOnline }) => {
  return (
    <span className="team-auto-offline-status">
      Team is currently&nbsp;
      <strong className={cx({ 'team-status-online': isOnline }, { 'team-status-offline': !isOnline })} >
        {isOnline ? 'online' : 'offline'}
      </strong>
      &nbsp;based on team availability
    </span>
  )
}

const TeamAutoOfflineManager = props => {
  const { autoOffline, handleChangeAutoOfflineToggle, activeCount, team, teamAvailabilities} = props
  const teamAvailability = teamAvailabilities.find(ta => ta.id === team.teamAvailabilityId)

  return (
    <div className="team-auto-offline-container">
      {team.teamAvailabilityMode !== HOURS_AVAILABILITY_MODES.ALWAYS_OFFLINE &&
        <ToggleSection
          title="Go offline when all teammates are away"
          description="When all teammates are away, this team will automatically go offline."
          isActive={autoOffline}
          onToggled={handleChangeAutoOfflineToggle}
        />
      }
      <AvailabilityLabel isOnline={isTeamOnline(activeCount, autoOffline, team, teamAvailability)}/>
    </div>
  )
}

export default TeamAutoOfflineManager



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Teams/TeamAutoOfflineManager/component.js